import type { CellProps } from 'react-table';
import type { FoldersTableItem } from './interfaces';
import { Tags } from './Tags';

export default function FolderTags({ row: { original: data } }: CellProps<FoldersTableItem>) {
  return <Tags tags={data.tags} maxTags={1} />;
}

export { FolderTags };